/* eslint-disable */

import { Cookie } from './cookie';
import { HeightAnim } from './utils';
/**
 * Initialize load more, attaches click event to button with load more function
 *
 * @param poll_form
 * @param answer
 * @param answer_id
 */
export function initUpdatePoll(poll_form, answer, answer_id) {
    console.log('drukajlo');
    console.log('drukajlo');
	const poll_cookie = new Cookie({ cookieName: `Poll-${ poll_form.dataset.poll }`, cookieValue: answer, cookieExpire: 100 });
	fetch(`/wp-json/custom/poll_vote?poll=${ poll_form.dataset.poll }&user_ip=${ poll_form.dataset.user }&answer=${ answer }&answer_id=${ answer_id }`)
		.then(response => response.json())
		.then(data => {
			//poll_form.querySelector('.loading').classList.remove('loading');

			poll_cookie.setCookie();

			initPollResults(poll_form);
		})
		.catch(err => {
            console.log(err);
			poll_form.querySelector('.loading').classList.remove('loading');
			console.error('Voting error: ', err);
		});
}

/**
 *
 * @param poll_form
 */
export function initPollResults(poll_form) {
	const poll_cookie = new Cookie({});

	poll_form.classList.add('loading');
	// poll_form.style.height = '300px';
	poll_form.innerHTML = '';
	fetch(`/wp-json/custom/poll_results?poll=${ poll_form.dataset.poll }`)
		.then(response => response.json())
		.then(json => {
			let html = '';
			json.data.forEach(option => {
				const { answer, percent } = option;
				html += `<div class="answer-result">
                            <div class="result-numbers">
                                <div class="custom__progress" style="width: ${ percent };"></div>
                            </div>
                            <p class="result-percent">${ percent }</p>
                            <p class="result-answer">${ answer }</p>
                        </div>`;
			});
			if ( !poll_cookie.getCookie(`Poll-${ poll_form.dataset.poll }`) ) {
				html += '<div class="form-group buttons"><button type="button" class="btn btn--purple--outline load-poll">Nazad na anketu</button></div>';
			}
			poll_form.innerHTML = html;
			// new HeightAnim(poll_form);
			poll_form.classList.remove('loading');
		})
		.catch(err => {
			console.error('Voting error: ', err);
			poll_form.classList.remove('loading');
		});
}

export function loadPoll({ poll_form, poll_id } = {}) {

	poll_form.classList.add('loading');
	// poll_form.style.height = '300px';
	poll_form.innerHTML = '';
	fetch(`/wp-json/custom/get_poll?poll_id=${ poll_id }`)
		.then(response => response.json())
		.then(data => {
			poll_form.innerHTML = data;
			new HeightAnim(poll_form);
			poll_form.classList.remove('loading');
		})
		.catch(err => {
			console.error('Poll error: ', err);
			poll_form.classList.remove('loading');
		});
}



// WEBPACK FOOTER //
// ./scripts/modules/poll.js